import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DomainService} from '../../../services/domain.service';
import {Router} from '@angular/router';
import {TopLevelDomainVO} from '../../../generate/TopLevelDomainVO';
import {AuthService} from '../../../services/auth.service';
import {HistoryHelperService} from '../../../services/history-helper.service';

@Component({
  selector: 'lib-domains-list-view',
  templateUrl: './domains-list-view.component.html',
  styleUrls: ['./domains-list-view.component.scss']
})
export class DomainsListViewComponent implements OnInit, OnDestroy {
  searchText = '';
  domains: TopLevelDomainVO[] = [];
  pageNumber = 0;
  private totalPages = -1;
  statusFilterOptions = ['All', 'Active', 'Inactive', 'Former', 'Reserved', 'Eligible'];
  statusFilterOptionSelected: string = this.statusFilterOptions[0];
  private readonly FILTER_KEY = 'domains';

  @Input()
  staffView: Boolean;

  @Output()
  createDomain = new EventEmitter<void>();

  @Output()
  editDomainOutput = new EventEmitter<string>();

  constructor(private domainService: DomainService, private router: Router, private auth: AuthService, private historyHelperService: HistoryHelperService) {
  }

  ngOnInit() {
    let filterHistory = this.historyHelperService.getHistory(this.FILTER_KEY);
    if(filterHistory == null){
      this.statusFilterOptionSelected = this.statusFilterOptions[0];
      this.searchText = '';
      this.pageNumber = 0;
    }else {
      this.statusFilterOptionSelected = filterHistory.filterOptionSelected;
      this.searchText = filterHistory.searchText;
      this.pageNumber = 0;
    }

    this.filter(this.searchText);
  }

  ngOnDestroy(): void {
    const history = {
      searchText: this.searchText,
      filterOptionSelected: this.statusFilterOptionSelected
    };

    this.historyHelperService.storeHistory(this.FILTER_KEY, history);
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  changeFilter() {
    this.searchText = '';
    this.search();
  }

  search() {
    this.pageNumber = 0;
    this.totalPages = -1;
    this.domains = [];
    this.filter(this.searchText.trim());
  }

  filter(searchText: string) {
    if (this.totalPages === -1 || this.pageNumber < this.totalPages) {
      this.domainService.getListOfDomains(this.pageNumber, 30, this.statusFilterOptionSelected, searchText).subscribe(data => {
        this.domains.push(...data.response);
        this.totalPages = data.totalPages;
      }, () => {
        console.log('Unable to retrive domains');
      }, () => {
        console.log(this.domains);
      });
    }
  }


  editDomain(domain: string) {
    this.router.navigate([`/domain/create-request/` + domain + '/direct-edit']);
  }

  onScroll() {
    this.pageNumber++;
    this.filter(this.searchText);
  }

  createDomainOutput() {
    this.createDomain.emit();
  }

  viewDomain(domainId: string) {
    this.router.navigateByUrl(`/domain/view/` + domainId);
  }
}
